/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { UpdateTruckMutation, UpdateTruckMutationVariables } from "@models/graphql";

const defaultUpdateTruckOptions: MutationHookOptions<UpdateTruckMutation, UpdateTruckMutationVariables> = {

};

export const useUpdateTruck = (options?: MutationHookOptions<UpdateTruckMutation, UpdateTruckMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<UpdateTruckMutation, UpdateTruckMutationVariables>(GraphQLDocuments.updateTruck);

    const updateTruck = async (variables: UpdateTruckMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultUpdateTruckOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        updateTruck
    };
};
